import plugin from 'tailwindcss/plugin';

const spacing = {
  0: '0',
  '1/2': '50%',
  '1/3': '33.333333%',
  '2/3': '66.666667%',
  '1/4': '25%',
  '2/4': '50%',
  '3/4': '75%',
  '1/5': '20%',
  '2/5': '40%',
  '3/5': '60%',
  '4/5': '80%',
  '1/6': '16.666667%',
  '2/6': '33.333333%',
  '3/6': '50%',
  '4/6': '66.666667%',
  '5/6': '83.333333%',
  '1/12': '8.333333%',
  '2/12': '16.666667%',
  '3/12': '25%',
  '4/12': '33.333333%',
  '5/12': '41.666667%',
  '6/12': '50%',
  '7/12': '58.333333%',
  '8/12': '66.666667%',
  '9/12': '75%',
  '10/12': '83.333333%',
  '11/12': '91.666667%',
  full: '100%',

  '1/8e': '0.125rem',
  '1/4e': '0.25rem',
  '1/3e': '0.33rem',
  '1/2e': '0.5rem',
  '2/3e': '0.66rem',
  '3/4e': '0.75rem',
  '1e': '1rem',
  '1_125e': '1.125rem',
  '1_25e': '1.25rem',
  '1_5e': '1.5rem',
  '1_75e': '1.75rem',
  '2e': '2rem',
  '2_125e': '2.125rem',
  '2_25e': '2.25rem',
  '2_5e': '2.5rem',
  '3e': '3rem',
  '3_5e': '3.5rem',
  '4e': '4rem',
  '4_5e': '4.5rem',
  '5e': '5rem',
  '6e': '6rem',
  '7e': '7rem',
  '8e': '8rem',
  '8_5e': '8.5rem',
  '9e': '9rem',
  '10e': '10rem',
  '11e': '11rem',
  '12e': '12rem',
  '13e': '13rem',
  '14e': '14rem',
  '15e': '15rem',
  '16e': '16rem',
  '17e': '17rem',
  '18e': '18rem',
  '20e': '20rem',
  '22e': '22rem',
  '25e': '25rem',
  '30e': '30rem',
  '32e': '32rem',
  '35e': '35rem',
  '37e': '37rem',
  '40e': '40rem',
  '45e': '45rem',
  '50e': '50rem',
  '55e': '55rem',
  '60e': '60rem',
  '70e': '70rem',
  '75e': '75rem',
  '80e': '80rem',
  '85e': '85rem',
  '90e': '90rem',
};

const colors = {
  transparent: 'transparent',
  black: '#000',
  white: '#fff',

  gray: {
    100: '#f7fafc',
    200: '#edf2f7',
    300: '#e2e8f0',
    400: '#cbd5e0',
    500: '#a0aec0',
    600: '#718096',
    700: '#3d516c',
    800: '#2d3748',
    900: '#1a202c',
    0: '#0E282D',
    1: '#638b8f',
    2: '#99ACAE',
    3: '#AAB3B5',
    4: '#A0B1B3',
    5: '#E9EFF0',
    6: '#D7D7D7',
    7: '#FCFCFC',
    8: '#A0B1B3',
    9: '#E9EFF0',
    10: '#979797',
    11: '#CFD8DC',
    12: 'rgba(0, 0, 0, 0.1)',
    13: '#6E7E81',
    15: '#7E8D90',
    17: 'rgba(83, 113, 117, 0.17)',
    18: '#AAB3B5',
    19: '#DAE0E1',
    20: '#A2B2B4',
    21: '#0D1C1E',
    22: '#EFF4F4',
    23: '#7C8A8D',
    26: '#ABABAB',
    27: '#CBD4D5',
    28: '#475767',
    light: '#F6F6F9',
    box: '#888888',
  },
  cyan: {
    1: '#71DBE1',
    2: '#53A3A8',
  },
  coral: {
    1: '#FF7470',
    2: '#fcefee',
    3: '#e68983',
    4: 'rgba(255, 116, 112, 0.1)',
  },
  red: {
    1: '#E2756E',
    2: '#FF6565',
    100: '#fff5f5',
    200: '#fed7d7',
    300: '#feb2b2',
    400: '#fc8181',
    500: '#f56565',
    600: '#e53e3e',
    700: '#c53030',
    800: '#9b2c2c',
    900: '#742a2a',
  },
  orange: {
    1: '#EBA289',
    2: '#F0A281',
    100: '#fffaf0',
    200: '#feebc8',
    300: '#fbd38d',
    400: '#f6ad55',
    500: '#ed8936',
    600: '#dd6b20',
    700: '#c05621',
    800: '#9c4221',
    900: '#7b341e',
  },
  yellow: {
    100: '#fffff0',
    200: '#fefcbf',
    300: '#faf089',
    400: '#f6e05e',
    500: '#ecc94b',
    600: '#d69e2e',
    700: '#b7791f',
    800: '#975a16',
    900: '#744210',
  },
  green: {
    1: '#99DB98',
    2: '#38A0B1',
    3: '#d1ebed',
    4: '#d1e8ed',
    100: '#f0fff4',
    200: '#c6f6d5',
    300: '#9ae6b4',
    400: '#4dcb7e',
    500: '#48bb78',
    600: '#38a169',
    700: '#2f855a',
    800: '#276749',
    900: '#22543d',
  },
  teal: {
    1: '#6CB3C4',
    2: '#3F9EA8',
    3: '#146368',
    4: '#39A1B2',
    5: '#3CA2B3',
    6: '#537175',
    7: 'rgba(98,216,223,0.32)',
    8: 'rgba(57, 161, 178, 0.1)',
    9: '#6C8A8E',
    /*
    100: '#e6fffa',
    200: '#b2f5ea',
    300: '#81e6d9',
    400: '#4fd1c5',
    500: '#38b2ac',
    600: '#319795',
    700: '#2c7a7b',
    800: '#285e61',
    900: '#234e52',
    */
  },
  blue: {
    templates: '#cbe9ee',
    1: '#F1F5F5',
    2: '#95CCD6',
    3: '#39A1B2',
    4: '#1C535C',
    5: 'rgba(23, 60, 57, 1)',
    6: '#D4DDDD',
    7: '#0076b7',
    8: '#36969B',
    9: '#70B2FF',
    100: '#ebf8ff',
    200: '#bee3f8',
    300: '#90cdf4',
    400: '#63b3ed',
    500: '#4299e1',
    600: '#3182ce',
    700: '#2b6cb0',
    800: '#2c5282',
    900: '#2a4365',
  },
  /*
  indigo: {
    100: '#ebf4ff',
    200: '#c3dafe',
    300: '#a3bffa',
    400: '#7f9cf5',
    500: '#667eea',
    600: '#5a67d8',
    700: '#4c51bf',
    800: '#434190',
    900: '#3c366b',
  },
  purple: {
    100: '#faf5ff',
    200: '#e9d8fd',
    300: '#d6bcfa',
    400: '#b794f4',
    500: '#9f7aea',
    600: '#805ad5',
    700: '#6b46c1',
    800: '#553c9a',
    900: '#44337a',
  },
  pink: {
    100: '#fff5f7',
    200: '#fed7e2',
    300: '#fbb6ce',
    400: '#f687b3',
    500: '#ed64a6',
    600: '#d53f8c',
    700: '#b83280',
    800: '#97266d',
    900: '#702459',
  },
  */

  rainbow: {
    1: '#39A1B2',
    2: '#ffa600',
    3: '#08b397',
    4: '#cdb304',
    5: '#42b87a',
    6: '#9dba32',
    7: '#70bb58',
    8: '#00abaa',
    9: '#008000',
    10: '#800000',
    11: '#008B8B',
    12: '#000080',
    13: '#0000CD',
    14: '#A0522D',
    15: '#800080',
    16: '#8B008B',
    17: '#A52A2A',
    18: '#A0522D',
    19: '#CD853F',
    20: '#BDB76B',
    21: '#006400',
    22: '#2E8B57',
    23: '#2F4F4F',
    24: '#5F9EA0',
    25: '#4682B4',
    26: '#708090',
    27: '#191970',
    28: '#483D8B',
    29: '#4B0082',
  },

  brand: {
    teal: {
      light: '#66b1ba',
      dark: '#2c6c78',
    },
    coral: {
      light: '#FF7470',
    },
  },

  chat: {
    bubble: '#49545f',
    moderatorBg: '#49545f',
    attendeeBg: '#E2E5E2',
    bg: '#f1f5f5',
    status: '#7a8588',
  },

  input: {
    field: '#0E282D',
    option: '#505050',
    box: '#A0B1B3',
  },

  plan: {
    red: '#FF7470',
    blue: '#459bff',
    green: '#99DB98',
    black: '#1a202c',
  },

  analytics: {
    gray: '#A7B2B5',
    blue: '#95CCD6',
    currency: '#ab8a69',
    lightBlue: '#70B2FF',
    coral: '#FF7470',
    teal: '#39A1B2',
    gold: '#F3A93C',
    background: '#FBFCFC',
    darkGreen: '#537175',
    attendees: 'rgba(149, 204, 214, 0.8)',
    chats: 'rgba(112, 178, 255, 0.8)',
    actions: 'rgba(243, 169, 60, 0.8)',
    likes: 'rgba(255, 116, 112, 0.8)',
  },

  header: {
    bg: '#ffffff',
    bgHover: '#6CB3C4',
    fg: '#3d516c',
    ctabg: '#FF7470',
    ctafg: '#ffffff',
    tabActiveBg: '#F1F5F5',
    tabActiveFg: '#3d516c',
    tabHoverBg: '#F1F5F5',
    tabHoverFg: '#638b8f',
    tabBorder: '#39A1B2',
    tabBg: '#fff',
    tabFg: '#638b8f',
    dark: '#808e90',
    darkHover: '#e1e4e5',
  },

  color: {
    'input-field': '#5A5B61',
    'input-box': '#A0B1B3',
    'input-option': '#505050',
    'input-placeholder': '#537175',

    'inroom-red': '#FF7470',
    whiteButton: '#8EA2A5',
    up: '#17c671',
    down: '#c4183c',
    border: '#E4EDED',
    borderLight: '#D1D6D6',
    cancel: '#638b8f',
    brand: '#39A1B2',
    brandLight: '#6CB3C4',
    brandBright: '#FF7470',
    'brand-dark': '#dfedee',
    buttonDark: '#537175',
    buttonBorder: '#bdcfce',
    menu: '#638b8f', //'#3c5457',
    menuActive: '#1a202c',
    cardTitle: '#323648',
    cardText: '#323648',
    link: '#99ACAE',
    title: '#323648',
    subtitle: '#3c4142',
    setting: '#638b8f',
    'interaction-setting': '#537175',
    'pagebuilder-frame': '#E5E5E5',
    'pagebuilder-frame-focus': '#FF7470',
    'pb-title': '#323648',
    'pb-text': '#5b5e6d',
    'date-time': '#39A1B1',
    iconGrey: '#abb7b8',
    arrowDown: '#537175',
    'card-outter': '#7C8A8D',
    'card-inner': '#39A1B2',
    delete: '#FF7470',
    'delete-row': '#FF7470',
    error: '#ff0c05',
    success: '#638b8f',
  },
};

export const screens = {
  sm: 640,
  md: 768,
  lg: 920,
  xl: 1280,
};

const config = {
  content: ['./src/**/*.{js,jsx,ts,tsx}'],

  mode: 'jit',
  future: {
    removeDeprecatedGapUtilities: true,
    purgeLayersByDefault: true,
  },

  important: true,

  screens,

  theme: {
    screens: {
      sm: `${screens.sm}px`,
      md: `${screens.md}px`,
      lg: `${screens.lg}px`,
      xl: `${screens.xl}px`,
    },
    zIndex: {
      1: '1',
      10: '10',
      20: '20',
      30: '30',
      40: '40',
      50: '50',
      60: '60',
      scrollModal: '61',
      'sso-form': '9999017',
      'sso-close-btn': '9999017',
      'page-section': '8',
      'nav-section': '9',
      'image-or-video': '10',
      dropdown: '10',

      'player-cards': '370',
      'player-roomarea': '390',
      'player-room-overlay': '400',
      'player-video-stage': '405',
      'player-roomarea-overlay': '406',
      'player-idock': '410',
      'player-non-clickable-overlay': '410',
      'player-controls-canvas': '411',
      'player-whiteout': '412',
      'player-pinned-card': '420',
      'player-actions-pane': '425',
      'player-likes': '500',
      'player-backdrop': '520',
      'player-controls-backdrop': '520',
      'player-clickable-overlay': '523',
      'player-control': '530',
      'player-new-like': '540',
      'player-drag': '540',
      'player-control-bar': '560',
      'player-bottom-whiteout': '565',
      'player-chat': '570',
      'player-change-video': '570',
      'player-actions-pane-focused': '590',
      'player-curtain': '600',
      'player-drag-edit': '600',
      'player-error': '600',
      'player-agenda': '700',

      'player-confetti': '890',
      'player-score': '900',

      'player-focused-card': '950',
      'player-acitonspane-overlay': '960',
      'player-timeline': '1000',
      'player-join': '1000',
      'analytics-player': '1001',
      'player-test-bar': '1100',

      timeline: '1000',
      'player-card-scroll-cover': '2000',
      'over-player': '2050',
      'admin-conversation': '9999',

      join: '9998000',
      'update-time': '9998010',
      'filter-header': '9998000',
      header: '9999000',
      notification: '9999001',
      progress: '9999009',
      modal: '9999010',
      'modal-footer': '9999015',
      'over-modal': '9999020',
      'upload-modal': '9999025',
      'player-embedded-overlay': '9999900',
      sidebar: '9999020',
      'dropdown-menu': '9999020',
      'sidebar-button': '9999021',
      'unsaved-changes': '9999040',
      drawer: '10000000000',
      'drawer-handle': '10000000010',
      themepicker: '9998999',
    },
    fontFamily: {
      title: ['Merriweather'],
      heading: ['DM Sans'],
      body: ['DM Sans'],
      code: ['DM Mono', 'monospace'],
      mono: ['DM Mono', 'monospace'],
    },
    fontWeight: {
      light: '300',
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
    },
    borderWidth: {
      DEFAULT: '1px',
      0: '0',
      2: '2px',
      4: '4px',
      8: '8px',
    },
    opacity: {
      0: '0',
      10: '.1',
      20: '.2',
      30: '.3',
      40: '.4',
      45: '.45',
      50: '.5',
      60: '.6',
      65: '.65',
      70: '.7',
      80: '.8',
      90: '.9',
      100: '1',
      disabled: '.6',
    },
    fontSize: {
      xxs: '.687em',
      xs: '0.75em',
      sm: '0.9em',
      base: '1em',
      md: '1em',
      lg: '1.125em',
      xl: '1.25em',
      '2xl': '1.5em',
      '3xl': '1.85em',
      '4xl': '2.25em',
      '5xl': '3em',
      '6xl': '4em',
      '16/5': '0.813em',
      '31/5': '1.563em',
      '3/4': '0.75em',
      '7/8': '0.875em',
      'size-input': '1em',
      title: '1.625em',
      chat: '1em',
      'chat-mobile': '1em',
      root: '1rem',
    },
    borderRadius: {
      none: '0',
      sm: '0.125rem',
      DEFAULT: '0.25rem',
      md: '0.375rem',
      lg: '0.5rem',
      xl: '0.75rem',
      '2xl': '1.5rem',
      full: '9999px',

      input: '6px',
      card: '0.875rem',
    },
    extend: {
      colors: {
        ...colors,
      },
      lineHeight: {
        ...spacing,
      },
      height: {
        ...spacing,
        '100vh': '100vh',
        input: '2.71428571em',
      },
      minHeight: {
        ...spacing,
        '60vh': '60vh',
        '80vh': '80vh',
        '100vh': '100vh',
        input: '2.71428571em',
      },
      maxHeight: {
        ...spacing,
        '1/4': '25vh',
        '1/2': '50vh',
        '3/4': '75vh',
        '45vh': '45vh',
        '100vh': '100vh',
      },
      width: {
        ...spacing,
      },
      minWidth: {
        ...spacing,
        'settings-field': '25rem',
        95: '95%',
        90: '90%',
      },
      maxWidth: {
        ...spacing,
        max: 'max-content',
      },
      padding: {
        ...spacing,
      },
      margin: {
        ...spacing,
      },
      boxShadow: {
        close: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
      },
    },
  },
  variants: {
    opacity: ['hover', 'focus', 'disabled', 'group-hover'],
    display: ['responsive', 'empty'],
  },
  plugins: [
    plugin(function ({ addVariant }) {
      addVariant('empty', '&:empty');
    }),
  ],
  content: ['./src/**/*.{tsx,ts,js}'],
};

export default config;
